import { StyleSheet, Platform } from 'react-native';

import { Fonts, Colors } from '../../Themes'

export default StyleSheet.create({
  itemCurrency: theme => ({
    color: Colors.ocean,
    fontFamily: Fonts.type.bold.fontFamily,
    ...Platform.select({
      android: {},
      ios: { fontWeight: 'bold' },
    }),
    fontSize: Platform.OS === 'ios' ? 49.9 : 48,
  }),
  currencyWrapper: (singleValue, isCurrencyFirst) => ({
    height: 50,
    justifyContent: 'center',
    alignItems: 'flex-start',
    minWidth: singleValue && !isCurrencyFirst ? null : 60,
    paddingStart: 16,
  }),
  itemText: theme => ({
    color: theme.colors.activeColorFour,
    fontFamily: Fonts.type.VFFont,
  }),
  itemWrapper: {
    alignItems: 'center',
    height: 30,
    justifyContent: 'center',
  },
  placeHolderViewStyle: {
    flex: 1,
  },
});
